
import React from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import rehypeRaw from "rehype-raw"
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/cjs/styles/hljs'
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { AppBar, IconButton, Toolbar, Typography } from "@mui/material";
import { Close, CloseFullscreen, CloseRounded } from "@mui/icons-material";

interface ToggleProps {
  toggle: [boolean, React.Dispatch<React.SetStateAction<boolean>>],
  markDownData: string
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MarkDownView(pops: ToggleProps) {

  const [open, setOpen] = pops.toggle
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>

      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={"xl"} fullScreen TransitionComponent={Transition}>
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseRounded />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Summary
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <ReactMarkdown rehypePlugins={[rehypeRaw]} components={{
            code({ node, inline, className, children, ...props }) {
              const match = /language-(\w+)/.exec(className || '')
              return !inline && match ? <Component value={String(children).replace(/\n$/, '')} language={match[1]}></Component> : (
                <code className={className} {...props}>
                  {children}
                </code>
              )
            }
          }}>
            {pops.markDownData}
          </ReactMarkdown>
        </DialogContent>
      </Dialog>
    </div>
  );
}


interface highlighterProps {
  value: string,
  language: string
}

const Component = (props: highlighterProps) => {
  return (
    <SyntaxHighlighter language={props.language} style={docco} >
      {props.value}
    </SyntaxHighlighter>
  );
};
